import React from 'react';

function Disclaimer() {
  return (
    <div style={{
      backgroundColor: '#0a0e1a',
      minHeight: '100vh',
      padding: '60px'
    }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: '40px' }}>
          <h1 style={{
            fontSize: '42px',
            fontWeight: '800',
            margin: '0 0 15px 0',
            color: '#ffffff',
            letterSpacing: '-0.5px'
          }}>
            Disclaimer
          </h1>
          <p style={{
            fontSize: '14px',
            color: '#64748b',
            margin: 0
          }}>
            Last Updated: February 20, 2026
          </p>
        </div>

        {/* Content */}
        <div style={{
          backgroundColor: '#1a1f2e',
          border: '1px solid #2d3748',
          borderRadius: '12px',
          padding: '40px',
          color: '#a0aec0',
          fontSize: '15px',
          lineHeight: '1.8'
        }}>
          <section>
            <p style={{ marginBottom: '15px' }}>
              Sports betting involves substantial risk of loss. Only wager what you can afford to lose. We provide informational tools and analytics only — we do not facilitate betting or guarantee accuracy, availability, or profitability. Odds change rapidly and opportunities may no longer exist by the time you act. Data and odds displayed may be delayed or inaccurate; always verify with your sportsbook before placing a wager. This Service is intended for use only where permitted by local law. It is your responsibility to verify that use of sports betting analytics tools is lawful in your jurisdiction. You are solely responsible for complying with all applicable laws where you reside. Must be 18+. If you or someone you know has a gambling problem, call 1-800-GAMBLER or visit ncpgambling.org.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Disclaimer;
